import { NEW_PATIENT_OPTION, PatientOption } from "../patient-field.component";

export default function createPatientFromInput(
  inputValue: string
): PatientOption {
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isPhoneNumber =
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/im;
  const newPatient: PatientOption = { ...NEW_PATIENT_OPTION };
  if (isEmail.test(inputValue)) {
    newPatient.email = inputValue;
  } else if (isPhoneNumber.test(inputValue)) {
    newPatient.phone = inputValue;
  } else {
    const splitInput = inputValue.split(" ");
    if (splitInput.length === 3) {
      newPatient.first_name = splitInput[0];
      newPatient.middle_name = splitInput[1];
      newPatient.last_name = splitInput[2];
    } else if (splitInput.length === 2) {
      newPatient.first_name = splitInput[0];
      newPatient.last_name = splitInput[1];
    } else {
      newPatient.first_name = inputValue;
    }
  }
  return newPatient;
}
